import ApiInvoker from './apiInvoker';

const { protocol } = window.location;


const requestObjCache = {};
const generateRequest = (module) => {
  let reqObj = requestObjCache[module];
  if (!reqObj) {
    reqObj = (suburl, data, options) => {
      const api = process.env.VUE_APP_API;
      const SERVER_API = `${api ? `${protocol}${api}` : ''}/api`;
      const nowApi = SERVER_API;
      return ApiInvoker.request(`${nowApi}/${module}${suburl ? `/${suburl}` : ''}`, data, options);
    };
    requestObjCache[module] = reqObj;
  }
  return reqObj;
};
export default generateRequest;
